import { useMutation, useQueryClient } from "@tanstack/react-query";

import { postWithdrawalApprovalWithdrawalRequestIDApprove } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";
import { WITHDRAWAL_APPROVALS_QUERY_KEYS } from "WithdrawalApprovals/Api/Queries/queryKeys";

export function useApproveWithdrawalMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      (withdrawalRequestID: string) =>
        postWithdrawalApprovalWithdrawalRequestIDApprove(withdrawalRequestID),
      {
        translationPrefix: getResourcePath(
          Resources.ApiErrors.ApproveWithdrawal,
        ),
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: WITHDRAWAL_APPROVALS_QUERY_KEYS.all,
      });
    },
  });
}
